import * as R from 'ramda';

export const isString = R.is(String);
export const isArray = R.is(Array);
export const isValidNumber = value => !Number.isNaN(value);

export const isNotNil: any = R.complement(R.isNil);
export const isNotEmpty: any = R.complement(R.isEmpty);
export const hasValue: any = R.allPass([isNotEmpty, isNotNil]);
export const hasNoValue: any = R.complement(hasValue);

export const capitalize: any = R.replace(/^./, <any>R.toUpper);
